/* 布局 */
//前台
import Layout from "@views/layout";

const syseditionRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "sysedition/list",
        name: "SYSEDITION",
        meta: {
            title: "教材版本",
        },
        component: () => import("@views/business/sysedition/index.vue"),
    },
        ],
};

export default syseditionRouter;
